module.exports = __webpack_public_path__ + "img/bg2.0c8e01f0.png";